/**
 * Código del Web Worker de encoding MP3 (lamejs vía importScripts).
 * Se instancia como Blob URL desde encodeMp3.js (CRA 3.4 sin worker-loader).
 *
 * Mensajes in:
 *   { type: 'encode', id, pcm: ArrayBuffer (Int16), sampleRate, bitrate, channels }
 * out:
 *   { type: 'ok', id, buffer: ArrayBuffer, mimeType: 'audio/mp3' }
 *   { type: 'error', id, message }
 */
export function getMp3EncoderWorkerSource(lameScriptUrl) {
  const urlJson = JSON.stringify(String(lameScriptUrl || ''))
  return `
var LAME_URL = ${urlJson};
var lameReady = false;
var lameError = null;

try {
  importScripts(LAME_URL);
  lameReady = true;
} catch (e) {
  lameError = (e && e.message) ? e.message : String(e);
}

function floatTo16(input) {
  var out = new Int16Array(input.length);
  for (var i = 0; i < input.length; i++) {
    var s = Math.max(-1, Math.min(1, input[i]));
    out[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
  }
  return out;
}

function encodePcm(pcmI16, sampleRate, bitrate, channels) {
  if (!lameReady || typeof lamejs === 'undefined') {
    throw new Error(lameError || 'lamejs no disponible en worker');
  }
  var ch = channels === 2 ? 2 : 1;
  var kbps = bitrate || 96;
  var mp3encoder = new lamejs.Mp3Encoder(ch, sampleRate, kbps);
  var blockSize = 1152;
  var mp3Data = [];
  var i = 0;
  if (ch === 1) {
    for (i = 0; i < pcmI16.length; i += blockSize) {
      var slice = pcmI16.subarray(i, i + blockSize);
      var mp3buf = mp3encoder.encodeBuffer(slice);
      if (mp3buf.length > 0) mp3Data.push(mp3buf);
    }
  } else {
    var left = new Int16Array(Math.ceil(pcmI16.length / 2));
    var right = new Int16Array(left.length);
    for (i = 0; i < left.length; i++) {
      left[i] = pcmI16[i * 2] || 0;
      right[i] = pcmI16[i * 2 + 1] || 0;
    }
    for (i = 0; i < left.length; i += blockSize) {
      var l = left.subarray(i, i + blockSize);
      var r = right.subarray(i, i + blockSize);
      var buf = mp3encoder.encodeBuffer(l, r);
      if (buf.length > 0) mp3Data.push(buf);
    }
  }
  var end = mp3encoder.flush();
  if (end.length > 0) mp3Data.push(end);
  var total = 0;
  for (i = 0; i < mp3Data.length; i++) total += mp3Data[i].length;
  var out = new Uint8Array(total);
  var offset = 0;
  for (i = 0; i < mp3Data.length; i++) {
    out.set(mp3Data[i], offset);
    offset += mp3Data[i].length;
  }
  return out.buffer;
}

self.onmessage = function (ev) {
  var msg = ev.data || {};
  var id = msg.id;
  try {
    if (msg.type !== 'encode') {
      throw new Error('mensaje desconocido');
    }
    var pcm;
    if (msg.pcmType === 'float32') {
      pcm = floatTo16(new Float32Array(msg.pcm));
    } else {
      pcm = new Int16Array(msg.pcm);
    }
    var buffer = encodePcm(pcm, msg.sampleRate || 44100, msg.bitrate || 96, msg.channels || 1);
    self.postMessage({ type: 'ok', id: id, buffer: buffer, mimeType: 'audio/mpeg' }, [buffer]);
  } catch (e) {
    self.postMessage({
      type: 'error',
      id: id,
      message: (e && e.message) ? e.message : String(e),
    });
  }
};
`
}
